import { JSONMapped, jsonProperty } from 'json-mapper-reflect';
import { SubscriptionResponseError } from './subscription-response-error';

export class SubscriptionResponse<T = null> extends JSONMapped() {

    @jsonProperty()
    success: boolean;

    @jsonProperty()
    statusCode: number;

    @jsonProperty()
    transactionUuid: string;

    @jsonProperty()
    jobUuid: string;

    @jsonProperty()
    errors: SubscriptionResponseError[];

    @jsonProperty()
    data: T;

    constructor(data?: Partial<SubscriptionResponse>) {
        super();
        Object.assign(this, data);
    }
}
